import React, {useState} from 'react';

import {DateRange} from 'react-date-range'
import {ptBR} from 'date-fns/locale'
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import {ContainerDate} from './styles'
import {addDays, endOfMonth, isAfter, startOfMonth, isSameMonth, isBefore, isAfter as isAfterFn} from "date-fns";

export default function DateRangePicker({onChange, dates, onlyIda = false}) {

    const minDate = addDays(new Date(), 3);
    const maxDate = addDays(new Date(), 365);
    
    const getInitialMonth = () => {
        const today = new Date();
        const endOfCurrentMonth = endOfMonth(today);
        if (isAfter(minDate, endOfCurrentMonth)) {
            return minDate;
        }
        return today;
    };

    const [shownDate, setShownDate] = useState(getInitialMonth());

    const handleChange = (rangeDate) => {
        setRange(rangeDate)
        onChange(rangeDate)
    };

    const handleSingleDate = (date) => {
        const single = [{ startDate: date, endDate: date, key: 'selection', color: '#00003C' }]
        setRange(single)
        onChange([{ startDate: date, endDate: null }])
    }

    const [range, setRange] = useState([
        {
            startDate: dates.startDate,
            endDate: onlyIda ? dates.startDate : dates.endDate,
            key: 'selection',
            color: '#00003C'
        }
    ]);

    const valid = !range[0].startDate && !range[0].endDate ? true : range[0].startDate && !range[0].endDate

    const atMin = isSameMonth(startOfMonth(shownDate), startOfMonth(minDate)) || isBefore(startOfMonth(shownDate), startOfMonth(minDate));
    const atMax = isSameMonth(startOfMonth(shownDate), startOfMonth(maxDate)) || isAfterFn(startOfMonth(shownDate), startOfMonth(maxDate));

    const handleShownDateChange = (value) => {
        if (value && value instanceof Date && !isNaN(value.getTime())) {
            setShownDate(value);
        }
    };

    return (
        <ContainerDate noDate={valid} className={`${atMin ? 'hide-prev' : ''} ${atMax ? 'hide-next' : ''}`}>
            {onlyIda ? (
                <DateRange
                    onChange={item => handleSingleDate(item.selection.startDate)}
                    showMonthAndYearPickers={false}
                    moveRangeOnFirstSelection={false}
                    showDateDisplay={false}
                    dateDisplayFormat="dd/MM/yyyy"
                    locale={ptBR}
                    minDate={minDate}
                    maxDate={maxDate}
                    shownDate={shownDate}
                    onShownDateChange={handleShownDateChange}
                    monthDisplayFormat="LLLL"
                    weekdayDisplayFormat="EEEEE"
                    ranges={range}
                    months={1}
                    className="calendarElement"
                    retainEndDateOnFirstSelection={false}
                />
            ) : (
                <DateRange
                    onChange={item => handleChange([item.selection])}
                    showMonthAndYearPickers={false}
                    moveRangeOnFirstSelection={false}
                    showDateDisplay={false}
                    dateDisplayFormat="dd/MM/yyyy"
                    locale={ptBR}
                    minDate={minDate}
                    maxDate={maxDate}
                    shownDate={shownDate}
                    onShownDateChange={handleShownDateChange}
                    monthDisplayFormat="LLLL"
                    weekdayDisplayFormat="EEEEE"
                    ranges={range}
                    months={1}
                    className="calendarElement"
                />
            )}
        </ContainerDate>
    );
}
